import React from 'react';
import { withRouter } from "react-router-dom";
import ReactJson from 'react-json-view'
class LookupJSON extends React.Component {
    constructor(props) {
        super(props);
        this.state = {

        };
    }

    render() {
        return (
            <ReactJson
                iconStyle={'triangle'}
                displayDataTypes={false}
                displayObjectSize={false}
                name={false}
                src={this.props.jsonData} />
        );
    }
}


export default withRouter(LookupJSON);


// WEBPACK FOOTER //
// ./src/components/Admin/Brands/Lookup Definition/LookupJSON.jsx